<template>
    <div class="login-warp">
            <!-- <div class="container demo-1">
        <div class="content">
            <div id="large-header" class="large-header">
                <canvas id="demo-canvas"></canvas> -->
                            <div class="login_cons">
                                <div class="login_tit">
                                    <img src="../../assets/img/bg.jpg" alt="" />
                                    <h2>智慧消防监测预警管理系统</h2>
                                </div>
                                <el-form :model="loginform" ref="loginform" label-position="left" label-width="0px" class="demo-ruleForm2 login-containers">
                                    <h3 class="title">用户登录</h3>
                                    <el-form-item prop="adminName">
                                        <el-input type="text" id="inp" :class="{'redBorder': select3}" v-model="loginform.adminName" auto-complete="off" placeholder="请输入用户名称" @blur="bluradmin" @input="disabledS(loginform.adminName,loginform.adminPassword,1)" clearable></el-input>
                                    </el-form-item>
                                    <el-form-item prop="adminPassword" id="password">
                                        <el-input ref="input" :type="passImg?'password':'text'" :class="{'redBorder': select3}" v-model="loginform.adminPassword" auto-complete="off" placeholder="请输入用户密码" @blur="blurSave"  @input="disabledS(loginform.adminName,loginform.adminPassword,2)" clearable @keyup.enter.native="handleLogin($event)"></el-input>
                                        <div @click="passImgClick" :class="passImg ? 'passImgHide' : 'passImgShow'"></div>
                                    </el-form-item>
                                    <div class="captcha clearfix" v-show="select1">
                                        <el-form-item prop="captcha">
                                            <el-input type="text" v-model="loginform.captcha" auto-complete="off" placeholder="请输入验证码"></el-input>
                                        </el-form-item>
                                        <img alt="" @click="getCode()" class="images"/>
                                    </div>
                                    <el-checkbox v-model="loginform.rememberme" class="remember" @click.native.prevent="remember()">记住密码</el-checkbox>
                                    <el-form-item style="width:100%;">
                                        <el-button type="primary" style="width:100%;" @click.native.prevent="handleLogin($event)" :loading="logining" :disabled="loginLength">登录</el-button>
                                    </el-form-item>
                                    <p v-show="select2">{{msg}}</p>
                                    <p v-show="select1"></p>
                                </el-form>
                            </div>
                            <div class="loginModel"></div>
                <!-- </div>
            </div>
            </div> -->
    </div>
</template>
<script>
    import {ajaxFuncJsonLogin} from '@/api/ajax';
    import {amountList1} from '@/api/ajax';
    export default {
        name: 'login',
        data () {
            return {
                logining: false,
                select1: false, //判断验证码是否显示
                select2: false, //提示语是否显示
                select3: false,
                msg: '', //提示语内容
                loginform: {
                    adminName: '', //用户名
                    adminPassword: '',  //密码
                    rememberme: false, //是否点击十天内免登录
                    captcha: '', //验证码
                    Code: false, //是否传入验证码
                },
                loginLength: false,
                passImg:true
            };
        },
        created() {
            if(localStorage.getItem('islogin') == 'true'){ //是否记住密码
                this.loginform.adminName = localStorage.getItem('adminName');
                this.loginform.adminPassword = localStorage.getItem('adminPassword');
                this.loginform.rememberme = true;
            }
        },
        mounted() {
           
        },
        methods: {
            passImgClick(){
                this.passImg = !this.passImg;
            },
            bluradmin(){
               this.select3 = false;
               this.select2 = false;
            },
            blurSave(){
              this.select3 = false;
              this.select2 = false;
              sessionStorage.setItem('changeadmin',this.loginform.adminName);
            },
            disabledS(name,pass,type) {  //判断登陆按钮是否是禁止状态
                if(name.length >= 8 && pass.length >= 6) {
                    this.loginLength = false;
                } else {
                    this.loginLength = true;
                }
                if(type == 1){ //用户名变动
                    if(this.loginform.adminName != sessionStorage.getItem('changeadmin') && this.loginform.adminPassword !=''){
                         this.loginform.adminPassword = '';
                         this.loginform.rememberme = false;
                         this.loginLength = true;
                      }
                    if(name != localStorage.getItem('adminName') && localStorage.getItem('islogin') == 'true'){
                            this.loginform.adminPassword = '';
                            this.loginform.rememberme = false;
                        }else{
                            if(localStorage.getItem('islogin') == 'true'){ //是否记住密码
                                this.loginform.adminName = localStorage.getItem('adminName');
                                this.loginform.adminPassword = localStorage.getItem('adminPassword');
                                this.loginLength = false;
                                this.loginform.rememberme = true;
                            }
                        }
                }

            },
            handleLogin(event) { // 用户登录
              // 表单提交
              event.preventDefault();
              let formData = new FormData();
              formData.append('userName', this.loginform.adminName);
              formData.append('password', this.loginform.adminPassword);
              formData.append('captcha', this.loginform.captcha);
              formData.append('Code', this.loginform.Code);
              formData.append('rememberMe', this.loginform.rememberme);
              sessionStorage.clear(); //清空缓存
              ajaxFuncJsonLogin('/auth_user/login',formData).then(res=>{
                if(res.data.status == 200) { // 成功
                    sessionStorage.clear();
                    localStorage.setItem('userName',res.data.data.userName); //用户名
                    localStorage.setItem('leaderType',res.data.data.leaderType); //领导
                    localStorage.setItem('loginName',res.data.data.loginName); //用户名
                    localStorage.setItem('avatar',res.data.data.avatar);  //用户头像
                    localStorage.setItem('userid',res.data.data.id);  //用户id
                    sessionStorage.setItem('userType',res.data.data.userType);  //客户id
                    if(res.data.data.userType == 0){
                        sessionStorage.setItem('customerId','')
                    }else{
                        sessionStorage.setItem('customerId',res.data.data.customerId);  //客户id
                    }
                    sessionStorage.setItem('customerId1',res.data.data.customerId);  //客户id
                    sessionStorage.setItem('token',res.data.data.token);  //客户token
                    sessionStorage.setItem('token3D',res.data.data.token);  //客户id
                    window.sessionStorage.removeItem('buildingId');
                    sessionStorage.setItem('islock',true)//消音器
                    if(res.data.data.userType ==0||res.data.data.userType ==3 || res.data.data.userType ==4){
                      sessionStorage.setItem('bureaucustomerId',res.data.data.customerId)
                    }

                    // 记住密码
                    if(this.loginform.rememberme == true){
                        localStorage.setItem('adminName', this.loginform.adminName); //账号
                        localStorage.setItem('adminPassword', this.loginform.adminPassword); //密码
                        localStorage.setItem('islogin', this.loginform.rememberme); //密码
                    }else{
                        localStorage.removeItem('adminName'); //账号
                        localStorage.removeItem('adminPassword'); //密码
                        localStorage.setItem('islogin', this.loginform.rememberme); //密码
                    }
                    //获取权限的接口
                    this.getPerssionList();
                } else if(res.data.status == 500) { // 出现验证码
                    this.select1 = true;
                    this.select2 = true;
                    this.msg = '你输入的密码和账户名不匹配，请重新输入！';
                    this.loginform.Code = true;
                    this.getCode();

                } else if(res.data.status == 405) { //错误提示
                    this.select2 = true;
                    this.select3 = true;
                    if(res.data.msg == '验证码输入有误!') {
                        this.msg = '你输入的验证码有误，请重新输入！';
                        this.getCode();
                    } else {
                        this.msg = res.data.msg;
                    }
                }
              });
            },
            getPerssionList(){
              ajaxFuncJsonLogin('/menu/nav','').then(res=>{
                if(res.data.status==200){
                  sessionStorage.setItem('permissions',JSON.stringify(res.data.data.permissions)||'[]');
                  // if(sessionStorage.getItem("userType") == 0){
                    // sessionStorage.setItem('router','mapIndexHome')
                    //   this.$router.push({path:'/mapIndexHome'});
                  // }
                  // else{
                  //     this.$router.push({path:'/Home'});
                  // }
                  this.$router.push({
                        path:'/mapIndex',
                        query:{
                        id:123
                    }
                  });
                }else {
                  this.$message({
                    message:res.data.msg,
                    type:'error'
                  })
                }
              });
            },
            remember() { // 是否点击记住密码登录
                if(this.loginform.rememberme) {
                    this.loginform.rememberme = false;
                } else {
                    this.loginform.rememberme = true;
                }
            },
            getCode() { // 获取验证码
                amountList1('/code/getCode','').then(res=>{
                    return 'data:image/jpeg;base64,' + btoa(
                        new Uint8Array(res.data)
                        .reduce((data, byte) => data + String.fromCharCode(byte), '')
                    );
                })
                .then(data => {
                    $('.images').attr('src',data);
                })
            },
        }
    }
</script>
<style lang="scss" scoped>
    @import "@/assets/css/mixin.scss";
    .login-warp {
        position: fixed;
        @include wh(100%,100%);
        @include bgImg('../../assets/img/login.jpg');
    }
    // .large-header{
    //     position: fixed;
    //     @include wh(100%,100%);
    //     @include bgImg('../../assets/img/login.jpg');
    // }
    #password{
        position: relative;
    }
    .passImgHide{
        width: 16px;
        height: 16px;
        position:absolute;
        top:17px;
        right:10px;
        @include bgImg('../../assets/img/passHide.png');
        cursor: pointer;
    }
    .passImgShow{
        width: 16px;
        height: 16px;
        position:absolute;
        top:17px;
        right:10px;
        @include bgImg('../../assets/img/passShow.png');
        cursor: pointer;
    }
    .login_cons {
        position: fixed;
        top: 50%;
        left: 50%;
        margin-top: -13px;
        -webkit-transform: translate(-50%, -50%);
           -moz-transform: translate(-50%, -50%);
            -ms-transform: translate(-50%, -50%);
             -o-transform: translate(-50%, -50%);
                transform: translate(-50%, -50%);
    }
    .loginModel {
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.3);
    }
    .login_tit {
        width: 496px;
        height: 36px;
        padding-left: 56.5px;
        img {
            float: left;
            @include wh(36px,36px);
            margin-right: 20px;
        }
        h2 {
            float: left;
            @include sizeColor(24px,#198cff);
            font-weight: bold;
        }
    }
    .login-containers {
        width: 440px;
        min-height: 470px;
        max-height: 535px;
        margin: 20px auto 0;
        padding: 0 35px 0 35px;
        @include borderRadius(5px);
        background-clip: padding-box;
        background: #fff;
        input::-ms-reveal{
            display: none;
        }
        .title {
            margin: 0px auto 40px auto;
            padding-top: 80px;
            @include sizeColor(24px,#282828);
        }
        .captcha {
            margin-bottom: 30px;
            img {
                float: right;
                @include wh(180px,48px);
                cursor: pointer;
            }
        }
        .remember {
            display: inline-block;
            margin: -15px 0px 25px 0px;
        }
        > p {
            margin-top: -10px;
            padding-bottom: 80px;
            @include sizeColor(13px,#f55353);
            text-align: center;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/login/index.vue